import React from 'react';

import ShortForm from 'patterns/ShortForm/ShortForm';

function WaitlistForm() {
  return (
    <ShortForm />
  );
}

export default React.memo(WaitlistForm);
